/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/EntityState/Form
 * @desc Filter EntityState form
 */

import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { ParamsStateContextProvider } from 'labstep-web/contexts/params-state';
import { SearchSelectContainer as SearchSelect } from 'labstep-web/core/Select/Search';
import { EntityState } from 'labstep-web/models/entity-state.model';
import { PostFilterEntityState } from 'labstep-web/services/postFilter/filters/entityState';
import type React from 'react';
import type { IFilterPostNewIndexEntityStateFormProps } from './types';

const FilterPostNewIndexEntityStateForm: React.FC<
  IFilterPostNewIndexEntityStateFormProps
> = ({ addPostFilter, onDone, activeGroup }) => {
  if (!activeGroup) {
    return null;
  }

  return (
    <ParamsStateContextProvider value={{}}>
      <SearchSelect
        entityName={EntityState.entityName}
        isClearable
        params={{
          group_id: activeGroup?.id,
          group_by_name: true,
        }}
        onChange={(selectedOption) => {
          if (addPostFilter) {
            addPostFilter(
              PostFilterEntityState.getNode([selectedOption?.name]),
            );
          }
          onDone();
        }}
      />
    </ParamsStateContextProvider>
  );
};

export default withActiveGroup(FilterPostNewIndexEntityStateForm);
